// extracted by mini-css-extract-plugin
module.exports = {"page404":"__404_page404__Asp4F","bg":"__404_bg___4DB_","btn":"__404_btn__2EVwe"};